<p>{{ 'productUpdates.information' | cxTranslate }}</p>

<div class="row justify-content-between mb-4">
  <div class="col-12 col-md-8 col-lg-5 col-xl-5 search">
    <app-custom-search-input
      [placeholder]="'productUpdates.searchHint' | cxTranslate"
      (eventSearch)="onSearch($event)"
    ></app-custom-search-input>
    <button type="button" class="btn btn-primary w-auto" (click)="onSearch(searchInputComponent.inputSearch)">
      {{ 'orderHistory.search' | cxTranslate }}
    </button>
  </div>
</div>

@if (quarterlyProductUpdates$ | async; as products) {
  @if ((products | keyvalue)?.length > 0) {
    @for (brand of products | keyvalue: brandOrder; track brand) {
      <mat-card class="mb-4">
        <div class="row">
          <div class="col-2">
            <ng-container *ngTemplateOutlet="brandImage; context: { brand: brand.key | lowercase }"></ng-container>
          </div>
          <div class="col-10">
            @for (year of brand.value | keyvalue: yearOrder; track year) {
              <mat-accordion>
                <mat-expansion-panel class="mb-2" [expanded]="expandedPath?.year">
                  <mat-expansion-panel-header>
                    <mat-panel-title
                      ><b>{{ year.key }}</b>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <!-- inner accordion -->
                  @for (quarter of year.value | keyvalue: quarterOrder; track quarter) {
                    <mat-accordion>
                      <mat-expansion-panel class="mb-2" [expanded]="expandedPath?.quarter">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <b>{{ quarter.key }} {{ year.key }} </b>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-container
                          *ngTemplateOutlet="productUpdatesTable; context: { products: quarter.value }"
                        ></ng-container>
                      </mat-expansion-panel>
                    </mat-accordion>
                  }
                  <!-- inner accordion -->
                </mat-expansion-panel>
              </mat-accordion>
            }
          </div>
        </div>
      </mat-card>
    }
  } @else {
    <app-custom-error [errorMessage]="'shared.noEntries' | cxTranslate"></app-custom-error>
  }
}

<ng-template #brandImage let-brand="brand">
  @switch (brand) {
    @case ('tena') {
      <img src="/public/images/tena-logo.png" alt="tena logo" class="w-100" />
    }
    @case ('tork') {
      <img src="/public/images/tork-logo.png" alt="tork logo" class="w-100" />
    }
    @case ('libra') {
      <img src="/public/images/libra-logo.png" alt="libra logo" class="w-100" />
    }
    @default {
      <span>No logo available</span>
    }
  }
</ng-template>

<ng-template #productUpdatesTable let-products="products">
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="productCode"
    override="ProductUpdatesRow"
    [rows]="products"
  ></app-custom-table>
</ng-template>


@if (showInitialLoader$ | async) {
  <cx-spinner></cx-spinner>
}
